import { Injectable} from '@angular/core';
import { SignalService } from '@app/fremework/signal.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService extends SignalService<boolean> {

  public once: boolean = false;

  constructor() {
    super();
  }

  public toggleOpen$(): Observable<boolean> {
    return this.obervableSignal$
  }

  public openOnce(): void {
    if(!this.once) {
      this.pushSignal(true);
      this.once = true;
    }
  }

}
